import { lazy, Suspense } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import FloatingLogo from "../components/FloatingLogo";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PayPalDonate from "../components/PayPalDonate";
import { Styles } from "../styles/styles";
import routes from "./config";

const Router = () => {
	const { pathname } = useLocation();
	// The donate button would be redundant on the page shown right after donating,
	// and on the event pages it lands on top of the embedded form's own controls.
	const hideDonateButton =
		pathname.startsWith("/thank-you") || pathname.startsWith("/events/");

	return (
		<Suspense fallback={null}>
			<Styles />
			<FloatingLogo />
			{!hideDonateButton && <PayPalDonate />}
			<Header />
			<main>
				<Switch>
					{routes.map((routeItem) => {
						return (
							<Route
								key={routeItem.component}
								path={routeItem.path}
								exact={routeItem.exact}
								component={lazy(
									() =>
										import(
											`../pages/${routeItem.component}`
										),
								)}
							/>
						);
					})}
				</Switch>
			</main>
			<Footer />
		</Suspense>
	);
};

export default Router;
